import Vue from 'vue';

Vue.component('phoenix-wrapper', require('./PhoenixWrapper').default);